import React, { useMemo, useState } from 'react';

import { Box, SxProps } from '@mui/material';
import { TBlock } from '@wp-block-builder/package';
import { BRAND_GREEN } from '@wp-constants/colors';

import { useEvaluatedHiddenCondition } from '../../document-layout/hooks';
import ReadOnlyBlock from '../../ReadOnlyMessage/Block';

type Props = {
  block: TBlock;
};
export default function LayoutReadOnlySection({ block }: Props) {
  const hidden = useEvaluatedHiddenCondition(block);
  const [isHover, setIsHover] = useState(false);
  const wrapperStyle = useMemo<SxProps>(
    () => ({
      position: 'relative',
      '&::after': {
        outline: isHover ? `2px solid ${BRAND_GREEN}` : undefined,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        content: `""`,
        outlineOffset: '-1px',
        pointerEvents: 'none',
        zIndex: 5,
      },
    }),
    [isHover]
  );

  if (hidden) {
    return null;
  }
  return (
    <Box
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      sx={wrapperStyle}
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      <ReadOnlyBlock block={block} />
    </Box>
  );
}
